 import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
//page links  
import './statusbar.css';
import { VscArrowLeft } from "react-icons/vsc";
import { IoIosHelpCircle, IoIosHelpCircleOutline } from "react-icons/io";
import { MdHome } from 'react-icons/md';
export default function Statusbar({ data }) {
  const navigate = useNavigate();
  const location = useLocation();
  //
 

const handleBack = () => {
  if (location.key !== "default") {
    navigate(-1);   // go back if there is history
  } else {
    navigate('/');  // fallback to home
  }
};
    useEffect(() => {
   
      const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
        handleBack();
        }
        else if (event.key === 'Enter') {
        }
      };
  
      window.addEventListener('keydown', handleKeyDown);
  
      // Cleanup on unmount
      return () => {
        window.removeEventListener('keydown', handleKeyDown);
      };
    }, []);
  return (
    <div className="status-bar">
      <div >
        <div className="status-bar_size">
          <div className='left_body'>
           
            <VscArrowLeft onClick={handleBack} className='back_arrow_btn' />
          </div>
          <div className='name-bar-body text-h2 fcap'>{data}</div>
          <div className='right_body'>
            
            <div
              onClick={() => navigate('/help')}
              className={`menubutton-icon cursor  ${location.pathname === '/help' ? 'active' : ''}`}
              title="Help Center"
            >
              {location.pathname === '/help' ? <IoIosHelpCircle className="icon" /> : <IoIosHelpCircleOutline className="icon" />}
 
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
